












































































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Transporteur} from '@/models';

import CrudTransporteurFilter from '@/components/Crud/Transporteur/Filter.vue';
import CrudTransporteurShowDialog from '@/components/Crud/Transporteur/ShowDialog.vue';
import CrudTransporteurEditDialog from '@/components/Crud/Transporteur/EditDialog.vue';
import CrudTransporteurList from '@/components/Crud/Transporteur/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storeTransporteur, {TransporteurFilter} from '@/stores/modules/transporteur';

@Component({
	components: {
		CrudTransporteurFilter,
		CrudTransporteurShowDialog,
		CrudTransporteurEditDialog,
		CrudTransporteurList,
		CrudDeleteDialog,
	}
})
export default class TransporteurView extends Vue {
	
	@Stored(() => storeTransporteur)
	private transporteurs!: ResultType<Transporteur>;
	
	@Stored(() => storeTransporteur)
	private filters!: TransporteurFilter;

	private showTransporteur: Transporteur = null;
	private editTransporteur: Transporteur = null;
	private deletedTransporteur: Transporteur = null;
	private storeTransporteur = storeTransporteur;

	@Emit()
	private onCreate(): void {
		var oNewTransporteur = new Transporteur();
		oNewTransporteur.listOrder = 99;
		this.editTransporteur = oNewTransporteur;
	}

	public mounted(): void {
		console.log("Mounted transporteur");
		this.filters.clear();
	}

	private refresh(): void {
		storeTransporteur.dispatch('getC', { filters: true });
	}
}
